import React from 'react';
import { TemplateEditorProvider } from './context/TemplateEditorContext';
import TemplateEditorLayout from './components/TemplateEditorLayout';

const CreateTemplatePage = () => {
  return (
    <TemplateEditorProvider>
      <TemplateEditorLayout
        pageTitle="Criar Modelo | neo-modelos"
        title="Criar Modelo"
        subtitle="Monte seu modelo com campos dinâmicos e edite o conteúdo como em um editor de texto."
      />
    </TemplateEditorProvider>
  );
};

export default CreateTemplatePage;
